import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';

interface AbandonModalProps {
    onClose: () => void;
    onConfirm: () => void;
}

export const AbandonModal: React.FC<AbandonModalProps> = ({ onClose, onConfirm }) => (
    <ModalWrapper onClose={onClose} borderColor="#ef4444">
        <AlertTriangle size={48} color="#ef4444" style={{ margin: '0 auto 20px' }} />
        <h2 style={{ ...UI.text.title, fontSize: 20, marginBottom: 10 }}>Abandon Activity?</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button className="premium-btn-primary" style={{ ...UI.button.primary, backgroundColor: "#fff", color: "#000", borderColor: "transparent" }} onClick={onClose}>RESUME TRAINING</button>
            <button onClick={onConfirm} style={{ all: 'unset', color: '#ef4444', fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '2px', cursor: 'pointer', padding: '10px' }}>Yes, Abandon Activity</button>
        </div>
    </ModalWrapper>
);
